export default {
  partner_management: ['partner_management'],
  partner_edit: ['partner_edit'],
  partner_delete: ['partner_delete'],
  partner_add: ['partner_add'],
  partner_archive: ['partner_archive'],
  partner_restore: ['partner_restore'],
  partner_confirm_status_markup: ['partner_confirm_status_markup'],

  partner_document_management: ['partner_document_management'],
  partner_document_edit: ['partner_document_edit'],
  partner_document_delete: ['partner_document_delete'],
  partner_document_add: ['partner_document_add'],
  partner_document_archive: ['partner_document_archive'],
  partner_document_restore: ['partner_document_restore'],

  partner_commodity_management: ['partner_commodity_management'],
  partner_commodity_edit: ['partner_commodity_edit'],
  partner_commodity_delete: ['partner_commodity_delete'],
  partner_commodity_add: ['partner_commodity_add'],
  partner_commodity_archive: ['partner_commodity_archive'],
  partner_commodity_restore: ['partner_commodity_restore'],

  partner_contact_management: ['partner_contact_management'],
  partner_contact_edit: ['partner_contact_edit'],
  partner_contact_delete: ['partner_contact_delete'],
  partner_contact_add: ['partner_contact_add'],
  partner_contact_archive: ['partner_contact_archive'],
  partner_contact_restore: ['partner_contact_restore'],

  partner_business_opportunity_management: ['partner_business_opportunity_management'],
  partner_business_opportunity_edit: ['partner_business_opportunity_edit'],
  partner_business_opportunity_delete: ['partner_business_opportunity_delete'],
  partner_business_opportunity_add: ['partner_business_opportunity_add'],
  partner_business_opportunity_replicate: ['partner_business_opportunity_replicate'],
  partner_business_opportunity_archive: ['partner_business_opportunity_archive'],
  partner_business_opportunity_restore: ['partner_business_opportunity_restore'],

  partner_bank_management: ['partner_bank_management'],
  partner_bank_add: ['partner_bank_add'],
  partner_bank_edit: ['partner_bank_edit'],
  partner_bank_delete: ['partner_bank_delete'],
  partner_bank_archive: ['partner_bank_archive'],
  partner_bank_restore: ['partner_bank_restore'],
  partner_approve_contract: ['partner_approve_contract'],

  partner_task_completion_time_management: ['partner_task_completion_time_management'],
  partner_task_completion_time_add: ['partner_task_completion_time_add'],
  partner_task_completion_time_edit: ['partner_task_completion_time_edit'],
  partner_task_completion_time_delete: ['partner_task_completion_time_delete'],
  partner_task_completion_time_archive: ['partner_task_completion_time_archive'],
  partner_task_completion_time_restore: ['partner_task_completion_time_restore']
}
